export default {
    // namespaced: true,
    state: {
        user: {},
        cartNum: '', //此读者的购物车书量
        institution: '' // 详情页链接地址名称
    },
    mutations: {
        setUser(state: any, value: any) {
            state.user = value;
        },
        setCartNum(state: any, value: any) {
            state.cartNum = value;
        },
        setInstitution(state: any, value: any) {
            state.institution = value;
        },
    },
    actions: {},
}
